export default __webpack_public_path__ + "static/media/forbes.1ced1f61.mp4";